export default {
    'common.more': 'More',
    'common.collapse': 'Collapse',
    'common.noEmpty': 'Không được để trống',
    'common.validator.mobile': 'Định dạng sai của số điện thoại di động',
    'common.validator.email': 'Định dạng Kokoak surat sala',
    'common.validator.number': 'Hãy nhập số đúng',
    'common.validator.password': 'Bao gồm số, chữ cái và dấu gạch dưới, trong vòng {length} ký tự',
    'common.validator.maxLength': 'Trong vòng {length} ký tự',
    'common.btn.search': 'Tìm kiếm',
    'common.btn.reset': 'Reset',
    'common.btn.refresh': 'Dấu',
    'common.btn.add': 'Thêm mới',
    'common.btn.edit': 'soạn thảo',
    'common.btn.delete': 'xóa',
    'common.btn.confirm': 'Xác nhận',
    'common.btn.cancel': 'Hủy bỏ',
    'common.btn.update': 'Sửa đổi',
    'common.btn.yes': 'Vâng',
    'common.btn.no': 'Không',
    'common.btn.look': 'Kiểm tra xem',
    'common.btn.operate': 'Hoạt động',
    'common.datePicker.startDate': 'Thời gian bắt đầu',
    'common.datePicker.endDate': 'Thời gian kết thúc',
    'common.input.placeholder': 'Xin nhập',
    'common.default.option': ' Mời chọn',
    'common.tip': 'Mẹo',
    'common.edit.message': 'Bạn có chắc chắn để sửa đổi?',
    'common.success': 'Xong',
    'widget.alert.yes': 'Xác nhận',
    'widget.alert.no': 'Hủy bỏ',
    'nav.language': 'Cài đặt ngôn ngữ',
    'nav.language.select': 'Vui lòng nhập ngôn ngữ bạn đang sử dụng',
    'nav.bread.home': ' trang chủ',
    'language.zh': '简体中文',
    'language.mx': 'Mexican',
    'language.en': 'English',
    'language.vi': 'Tiếng việt nam',
    'language.id': 'Indonesian',
    'nav.version': 'Thông tin phiên bản',
    'version.version': 'Số phiên bản',
    'version.pushUser': 'Nhà sản xuất',
    'version.developer': 'Nhà phát triển',
    'version.releaseTime': 'Thời gian phát hành',
    'version.content': 'Nội dung phiên bản',
    'nav.login': 'Đăng nhập',
    'nav.logout': 'Lối thoát an toàn',
    'nav.logout.tips': '当前用户将会被注销并回到系统入口',
    'nav.logout.confirm': '确认注销当前用户？',
    'nav.password': 'Đổi mật khẩu',
    'nav.session.add': 'Thêm tài khoản',
    'nav.password.old': 'Mật khẩu cũ',
    'nav.password.new': 'Mật khẩu mới',
    'nav.password.newPasswordConfirm': 'Xác nhận mật khẩu mới',
    'nav.password.newPasswordConfirm.error': 'Mật khẩu đầu vào không nhất quán hai lần',
    'nav.historyback': 'Return! ',
    'nav.brand.text': 'Quản lý quỹ',
    'nav.account.title': 'Quản lý tài khoản',
    'nav.account.item.delete': 'Bạn có chắc muốn xoá tài khoản này không?',
    'nav.account.item.confirm.state': 'Bạn có chắc muốn tài khoản {state} không?',
    'nav.account.company.subTitle': 'Tài khoản công ty',
    'nav.account.company.searchForm.state': 'Trạng thái',
    'nav.account.company.searchForm.stateValue.enable': 'Kích hoạt',
    'nav.account.company.searchForm.stateValue.disable': 'Cấm sử dụng',
    'nav.account.company.tableColumn.accountId': 'Account ID',
    'nav.account.company.tableColumn.accountName': 'Tên ',
    'nav.account.company.tableColumn.currency': 'Tiền tệ',
    'nav.account.company.tableColumn.balance': 'Số dư tài khoản',
    'nav.account.company.tableColumn.cardNumber': 'Số thẻ ngân hàng',
    'nav.account.company.tableColumn.bankName': 'Trực thuộc ngân hàng',
    'nav.account.company.tableColumn.phone': 'Số điện thoại dự trữ',
    'nav.account.company.tableColumn.email': 'Email',
    'nav.account.company.tableColumn.createTime': 'Thời gian mở tài khoản',
    'nav.account.company.tableColumn.updateTime': 'Thời gian update',
    'nav.account.company.tableColumn.state': 'Trạng thái',
    'nav.account.company.tableColumn.operation': 'Hoạt động',
    'nav.account.company.columnBtn.recharge': 'Nạp tiền',
    'nav.account.company.formData.addTitle': 'Add thêm tài khoản công ty',
    'nav.account.company.formData.editTitle': 'Sửa tài khoản công ty',
    'nav.account.company.formData.accountName': 'tài khoản',
    'nav.account.company.formData.currency': 'Tiền tệ',
    'nav.account.company.formData.balance': 'Số tiền',
    'nav.account.company.formData.cardNumber': 'Số thẻ ngân hàng',
    'nav.account.company.formData.bankName': 'Trực thuộc ngân hàng',
    'nav.account.company.formData.phone': 'Số điện thoại dự trữ',
    'nav.account.company.formData.email': 'Email',
    'nav.account.company.formData.state': 'Trạng thái',
    'nav.account.company.formData.error.accountName.required': 'Tên tài khoản không thể rỗng',
    'nav.account.company.formData.error.currency.required': 'Tiền không thể rỗng',
    'nav.account.company.formData.recharge.title': 'Nạp tiền',
    'nav.account.company.formData.recharge.balance': 'Số dư tài khoản',
    'nav.account.company.formData.recharge.amount': 'Số tiền nạp ',
    'nav.account.company.formData.recharge.amount.required': 'Lượng nạp lại không nên rỗng',
    'nav.account.personal.subTitle': 'Bên tài sản',
    'nav.account.blacklist.subTitle': 'Quản lý danh sách đen',
    'nav.account.blacklist.pushItem.title': 'Danh sách đen các thông tin sau',
    'nav.account.blacklist.TriggerConditions.title': 'Triggering conditions',
    'nav.account.blacklist.TriggerConditions.overdueDays.title': 'Ngày quá hạn >= ',
    'nav.subjectMatter.title': 'Quản lý mục tiêu',
    'nav.subjectMatter.credit': 'Quản lý giải ngân',
    'nav.subjectMatter.credit.receipt': 'Bill của vay mượn',
    'nav.subjectMatter.credit.check': 'Xét duyệt giải ngân',
    'nav.subjectMatter.loan': 'Hạng mục vay',
    'nav.subjectMatter.loan.detail': 'Chi tiết thanh toán nợ ',
    'nav.subjectMatter.repayment': 'Quản lý thanh toán',
    'nav.subjectMatter.repayment.unpaid': 'Chi tiết về nợ',
    'nav.subjectMatter.repayment.repaid': 'Đã thanh toán',
    'nav.subjectMatter.repayment.detail': 'Chi tiết thanh toán nợ ',
    'nav.subjectMatter.repayment.result': 'Kết quả thanh toán',
    'nav.subjectMatter.repayment.penalty': 'Lịch sử lãi phạt',
    'nav.subjectMatter.cashDetail': 'Chi tiết khoản tiền',
    'nav.subjectMatter.cashDetail.table.clumn.customerId': 'Nhận diện khách hàng',
    'nav.subjectMatter.cashDetail.table.clumn.cameraId': 'Nhận diện! ',
    'nav.subjectMatter.cashDetail.table.clumn.amount': 'Số tiền biến động',
    'nav.subjectMatter.cashDetail.table.clumn.currency': 'Tiền tệ',
    'nav.subjectMatter.cashDetail.table.clumn.payNo': 'Số sao kê ',
    'nav.subjectMatter.cashDetail.table.clumn.fundAction': 'Hoạt động đầu',
    'nav.subjectMatter.cashDetail.table.clumn.fundType': 'Kiểu quỹ',
    'nav.subjectMatter.cashDetail.table.clumn.debit': 'Mà thua.',
    'nav.subjectMatter.cashDetail.table.clumn.remark': 'Ghi chú',
    'nav.subjectMatter.cashDetail.table.clumn.createTime': 'Thời gian tạo',
    'nav.subjectMatter.cashDetail.table.clumn.updateTime': 'Thời gian update',
    'cash.searchForm.cameraId': 'ID đơn hàng',
    'cash.searchForm.accountId': 'Account ID',
    'cash.searchForm.fundType': 'Kiểu quỹ',
    'cash.searchForm.debit': 'Loại hình biến động',
    'cash.tableData.payNo': 'Số sao kê ',
    'cash.tableData.lid': 'Số Bill ',
    'cash.tableData.cameraId': 'ID đơn hàng',
    'cash.tableData.id': 'Account ID',
    'cash.tableData.debit': 'Loại hình biến động',
    'cash.tableData.debit.add': 'cộng',
    'cash.tableData.debit.reduce': 'giảm',
    'cash.tableData.currency': 'Tiền tệ',
    'cash.tableData.amount': 'Số tiền biến động',
    'cash.tableData.fundType': 'Kiểu quỹ',
    'cash.tableData.fundType.tenant': 'Thường',
    'cash.tableData.fundType.personal': ' cá nhân ',
    'cash.tableData.fundType.cash': ' Rút ',
    'cash.tableData.remark': 'Miêu tả',
    'cash.tableData.remark.income': 'Thu nhập:',
    'cash.tableData.remark.expenditure': 'Chi tiêu:',
    'cash.tableData.createTime': 'Thời gian tạo',
    'repayment.unpaid.searchForm.rid': 'ID đơn hàng',
    'repayment.unpaid.searchForm.shouldTimeDateValue': 'Thời gian cần thanh toán',
    'repayment.unpaid.searchForm.finishTimeDateValue': 'Thời gian trả xong',
    'repayment.unpaid.searchForm.payState': 'Trạng thái',
    'repayment.unpaid.searchForm.doubleLoan': 'Cho dù khách hàng vay lại',
    'repayment.unpaid.operation': 'Thao tác vay',
    'repayment.unpaid.operation.manual': 'Thao tác tự đối chiếu xóa nợ ',
    'repayment.unpaid.operation.partial': 'Giảm phần',
    'repayment.unpaid.operation.substract': 'Giảm nợ',
    'repayment.unpaid.operation.settlement': 'Giải quyết bình thường',
    'repayment.unpaid.operation.extends': 'ZhanQi',
    'repayment.unpaid.view': 'Kiểm tra xem',
    'repayment.unpaid.view.detail': 'Chi tiết thanh toán nợ ',
    'repayment.unpaid.view.result': 'Kết quả thanh toán',
    'repayment.unpaid.tableData.cameraId': 'ID đơn hàng',
    'repayment.unpaid.tableData.productName': 'Tên sản phẩm',
    'repayment.unpaid.tableData.pauseStatus': 'Tạm dừng thu hồi nợ',
    'repayment.unpaid.tableData.noPauseStatus': 'Chưa tạm dừng thu hồi nợ',
    'repayment.unpaid.tableData.pauseRemark': 'Ghi chú',
    'repayment.unpaid.tableData.dialog.title.pasuse': 'Tạm dừng thu hồi nợ hóa đơn',
    'repayment.unpaid.tableData.dialog.title.resume': 'Tiếp tục thu hồi nợ hóa đơn',
    'repayment.unpaid.tableData.dialog.hint.pause': 'Vui lòng nhập ghi chú tạm dừng',
    'repayment.unpaid.tableData.dialog.hint.resume': 'Vui lòng nhập ghi chú tiếp tục',
    'repayment.unpaid.tableData.dialog.btn.cancel': 'Hủy',
    'repayment.unpaid.tableData.dialog.btn.pause': 'Tạm dừng',
    'repayment.unpaid.tableData.dialog.btn.resume': 'Tiếp tục',
    'repayment.unpaid.tableData.customerName': 'Họ tên',
    'repayment.unpaid.tableData.indexs': 'Số lần',
    'repayment.unpaid.tableData.shouldCapital': 'Tiền gốc cần trả',
    'repayment.unpaid.tableData.factCapital': 'Tiền gốc trả thực tế ',
    'repayment.unpaid.tableData.shouldInterest': 'Lãi suất cần trả',
    'repayment.unpaid.tableData.factInterest': 'Lãi suất trả thực tế',
    'repayment.unpaid.tableData.shouldFine': 'Lãi phạt cần trả ',
    'repayment.unpaid.tableData.factFine': 'Lãi phạt trả thực tế',
    'repayment.unpaid.tableData.shouldOtherTotalFee': 'Phí phục vụ cần trả',
    'repayment.unpaid.tableData.factOtherTotalFee': 'Phí phục vụ trả thực tế',
    'repayment.unpaid.tableData.shouldOverdueFee': 'Phí vi phạm hợp đồng cần trả',
    'repayment.unpaid.tableData.factOverdueFee': 'Phí vi phạm hợp đồng trả thực tế',
    'repayment.unpaid.tableData.subtractAmount': 'Giảm tổng số',
    'repayment.unpaid.tableData.shouldTime': 'Thời gian cần thanh toán',
    'repayment.unpaid.tableData.finishTime': 'Thời gian trả xong',
    'repayment.unpaid.tableData.isExtends': 'Trạng thái mở rộng',
    'repayment.unpaid.tableData.doubleLoan': 'Cho dù khách hàng vay lại',
    'repayment.unpaid.specialviet.form.title': 'Trả nợ',
    'repayment.unpaid.specialviet.form.totalAmount': 'Tổng số do',
    'repayment.unpaid.specialviet.form.paidAmount': 'Số tiền trả nợ này',
    'repayment.unpaid.specialviet.form.capitalAmount': 'Trả nợ gốc',
    'repayment.unpaid.specialviet.form.interestAmount': 'Lãi cho khoản hoàn trả này',
    'repayment.unpaid.specialviet.form.penaltyAmount': 'Tiền phạt cho khoản hoàn trả này',
    'repayment.unpaid.specialviet.form.unpaidAmount': 'Số tiền còn lại',
    'repayment.unpaid.specialviet.form.factTime.required': 'Thời gian trả nợ thực tế không thể để trống',
    'repayment.unpaid.specialviet.form.timestatus.label': 'Thời gian đến > Thời gian trả nợ thực tế của khách hàng,Yêu cầu phạt thêm',
    'repayment.unpaid.manualDialog.title': 'Thao tác tự đối chiếu xóa nợ',
    'repayment.unpaid.manualDialog.partPaymentData.unpaidAmount': 'Tổng chưa thanh toán ',
    'repayment.unpaid.manualDialog.partPaymentData.capitalAmount': 'Tiền gốc chưa thanh toán ',
    'repayment.unpaid.manualDialog.partPaymentData.interestAmount': 'Lãi suất chưa thanh toán còn lại',
    'repayment.unpaid.manualDialog.partPaymentData.paidAmount': 'Số tiền thanh toán lần này',
    'repayment.unpaid.manualDialog.partPaymentData.writeOffAmount': 'Số tiền đối chiếu xóa nợ lần này',
    'repayment.unpaid.manualDialog.manualRules.paidAmount.required': 'Giá trị đòi nợ này không thể là rỗng ',
    'repayment.unpaid.manualDialog.onManualPaidSubmit.success': 'Xoá bỏ thành công',
    'repayment.unpaid.manualDialog.onPartialPaidSubmit.success': 'Khoản thanh toán thành công',
    'repayment.unpaid.extendsDialog.onExtendsPaidSubmit.success': 'Triển khai thành công',
    'repayment.unpaid.partialDialog.title': 'Trang thao tác trả nợ một phần',
    'repayment.unpaid.partialDialog.htitle1': 'Số tiền chưa thanh toán hiện tại',
    'repayment.unpaid.partialDialog.htitle2': 'Kế hoạch thanh toán',
    'repayment.unpaid.partialDialog.htitle3': 'Thời gian trả nợ thực tế',
    'repayment.unpaid.partialDialog.unpaidData.paidAmount': 'Tổng đã thanh toán',
    'repayment.unpaid.partialDialog.unpaidData.unpaidAmount': 'Tổng chưa thanh toán',
    'repayment.unpaid.partialDialog.unpaidData.capitalAmount': 'Tiền gốc chưa thanh toán',
    'repayment.unpaid.partialDialog.unpaidData.interestAmount': 'Lãi suất chưa thanh toán',
    'repayment.unpaid.partialDialog.unpaidData.penaltyAmount': 'Lãi phạt chưa thanh toán',
    'repayment.unpaid.partialDialog.unpaidData.feesAmount': 'Phí phục vụ chưa thanh toán',
    'repayment.unpaid.partialDialog.calculateData.inputAmount': 'Số tiền thanh toán lần này',
    'repayment.unpaid.partialDialog.calculateData.trialCalculation': 'Kế hoạch thanh toán ',
    'repayment.unpaid.partialDialog.calculateData.unpaidAmount': 'Tổng tiền thanh toán thử ',
    'repayment.unpaid.partialDialog.calculateData.capitalAmount': 'Tiền gốc thanh toán thử',
    'repayment.unpaid.partialDialog.calculateData.interestAmount': 'Lãi suất thanh toán thử',
    'repayment.unpaid.partialDialog.calculateData.penaltyAmount': 'Lãi phạt thanh toán thử',
    'repayment.unpaid.partialDialog.calculateData.feesAmount': 'Phí phục vụ thanh toán thử ',
    'repayment.unpaid.partialDialog.calcPartRepaymentHandler.notNumber': ' Hãy nhập số đúng ',
    'repayment.unpaid.partialDialog.calcPartRepaymentHandler.validNumber': 'Hãy nhập số đúng',
    'repayment.unpaid.partialDialog.onPartailPaidSubmit.confirm': 'Số tiền trả nợ là {inputAmount}. Bạn có muốn tiếp tục không?',
    'repayment.unpaid.substractDialog.title': 'Hoạt động giảm hoàn trả',
    'repayment.unpaid.substractDialog.htitle2': 'Thử nghiệm giảm nợ',
    'repayment.unpaid.substractDialog.calculateData.inputAmount': 'Số tiền giảm này',
    'repayment.unpaid.substractDialog.calculateData.unpaidAmount': 'Giảm nợ',
    'repayment.unpaid.substractDialog.calculateData.capitalAmount': 'Trả nợ gốc',
    'repayment.unpaid.substractDialog.calculateData.interestAmount': 'Trả lãi',
    'repayment.unpaid.substractDialog.calculateData.penaltyAmount': 'Hình phạt hoàn trả',
    'repayment.unpaid.substractDialog.calculateData.feesAmount': 'Phí quản lý giảm nợ',
    'repayment.unpaid.substractDialog.onPartailPaidSubmit.confirm': 'Số tiền giảm này là {inputAmount}. Bạn có muốn tiếp tục không?',
    'repayment.unpaid.settlementDialog.title': 'Hoạt động bù trừ bình thường',
    'repayment.unpaid.extendsDialog.title': 'ZhanQi',
    'repayment.unpaid.extendsDialog.htitle1': 'Xác nhận số tiền gia hạn',
    'repayment.unpaid.extendsDialog.unpaidData.extendsAmount': 'Số tiền triển lãm',
    'repayment.unpaid.extendsDialog.unpaidData.extendsFee': 'Phí quản lý chậm trễ chưa trả',
    'repayment.unpaidDetail.title.repaidDetail': 'Chi tiết đợi thanh toán ',
    'repayment.unpaidDetail.title.repaidRecord': 'Lịch sử thanh toán',
    'repayment.unpaidDetail.title.substractRecord': 'Hồ sơ giảm nợ',
    'repayment.unpaidDetail.detailList.totalAmount': 'Tổng tiền cần trả',
    'repayment.unpaidDetail.detailList.couponAmount': 'Số tiền giảm phiếu giảm giá',
    'repayment.unpaidDetail.detailList.paidAmount': 'Số tiền đã thanh toán',
    'repayment.unpaidDetail.detailList.unpaidAmount': 'Tổng số tiền cần thanh toán còn lại',
    'repayment.unpaidDetail.detailList.capitalAmount': 'Tiền gốc còn lại',
    'repayment.unpaidDetail.detailList.interestAmount': 'Lãi suất còn lại',
    'repayment.unpaidDetail.detailList.penaltyAmount': 'Lãi suất còn lại',
    'repayment.unpaidDetail.detailList.feesAmount': 'Chi phí khác',
    'repayment.unpaidDetail.recordList.id': 'Mã số giao dịch thanh toán',
    'repayment.unpaidDetail.recordList.factTime': 'Thời gian nhận tiền thực tế',
    'repayment.unpaidDetail.recordList.factAmount': 'Số tiền nhận thực tế',
    'repayment.unpaidDetail.recordList.factCapital': 'Tiền gốc thu thực tế',
    'repayment.unpaidDetail.recordList.factInterest': 'Lãi suất thu thực tế',
    'repayment.unpaidDetail.recordList.factFine': 'Lãi phạt thu thực tế',
    'repayment.unpaidDetail.recordList.factFeeAmount': 'Chi phí khác',
    'repayment.unpaidDetail.recordList.remark': 'Ghi chú',
    'repayment.unpaidDetail.recordList.updateRemark': 'Sửa đổi ghi chú',
    'repayment.unpaidDetail.recordList.updateRemark.success': 'Thành công',
    'repayment.unpaidDetail.substractList.operator': 'Điều hành',
    'repayment.unpaidDetail.substractList.factTime': 'Thời gian hoàn trả',
    'repayment.unpaidDetail.substractList.factAmount': 'Giảm nợ',
    'repayment.unpaidDetail.substractList.factCapital': 'Trả nợ gốc',
    'repayment.unpaidDetail.substractList.factInterest': 'Trả lãi',
    'repayment.unpaidDetail.substractList.factFine': 'Hình phạt hoàn trả',
    'repayment.unpaidDetail.substractList.factFeeAmount': 'Trả các khoản phí khác',
    'repayment.unpaidDetail.substractList.remark': 'Nhận xét',
    'repayment.unpaidDetail.lastIndex': 'Vấn đề trước',
    'repayment.unpaidDetail.nextIndex': 'Vấn đề tiếp theo',
    'repayment.penalty.searchForm.cameraId': 'ID đơn hàng',
    'repayment.penalty.searchForm.shouldTimeDateValue': 'Thời gian cần thanh toán',
    'repayment.penalty.tableData.cameraId': 'ID đơn hàng',
    'repayment.penalty.tableData.productName': 'Tên sản phẩm',
    'repayment.penalty.tableData.customerName': 'Họ tên',
    'repayment.penalty.tableData.indexs': 'Số lần',
    'repayment.penalty.tableData.shouldFine': 'Lãi phạt tích lũy',
    'repayment.penalty.tableData.factFine': 'Lãi phạt trả thực tế',
    'repayment.penalty.tableData.state': 'Trạng thái',
    'repayment.penalty.tableData.shouldTime': 'Thời gian cần thanh toán',
    'repayment.penalty.view': 'Kiểm tra xem',
    'repayment.penalty.operation': 'Hoạt động',
    'repayment.doubleLoan.first': 'Nếu không',
    'repayment.doubleLoan.double': 'là',
    'loan.searchForm.cameraId': 'ID đơn hàng',
    'loan.searchForm.cardNo': 'CMND',
    'loan.searchForm.state': 'Trạng thái',
    'loan.searchForm.releaseTime': 'Thời gian giải ngân',
    'loan.searchForm.customerName': 'Họ tên',
    'loan.searchForm.phone': 'Số điện thoại dự trữ',
    'loan.tableData.cameraId': 'ID đơn hàng',
    'loan.tableData.productName': 'Tên sản phẩm',
    'loan.tableData.customerName': 'Họ tên',
    'loan.tableData.contractAmount': 'Số tiền trong hợp đồng',
    'loan.tableData.amount': 'Số tiền cần giải ngân',
    'loan.tableData.interest': 'Tổng lãi suất ',
    'loan.tableData.feeAmount': 'Phí phục vụ cần trả',
    'loan.tableData.loanCycle': 'Kỳ hạn',
    'loan.tableData.rate': 'Lãi suất',
    'loan.tableData.state': 'Trạng thái',
    'loan.tableData.createTime': 'Thời gian thẩm định thông qua ',
    'loan.tableData.reviewTime': 'Xem lại thời gian',
    'loan.tableData.releaseTime': 'Thời gian giải ngân',
    'loan.tableData.operation': 'Hoạt động',
    'loan.tableData.cancelLoan': 'Rút tiền',
    'loan.tableData.view': 'Xem kế hoạch trả nợ',
    'loan.tableData.viewRepayment': 'Xem chi tiết trả nợ',
    'loan.tableData.loanState.init': 'Đợi xét duyệt ',
    'loan.tableData.loanState.lending': 'Đã giải ngân',
    'loan.tableData.loanState.finish': 'Đã chốt sổ',
    'loan.tableData.loanState.writeoff': 'Đối chiếu xóa nợ',
    'loan.tableData.loanState.cancel': 'Hủy bỏ',
    'loan.tableData.loanState.fail': 'Cho vay thất bại',
    'loan.tableData.loanState.refuse': 'Thẩm định từ chối',
    'loan.tableData.loanState.transaction': 'Vay',
    'loan.tableData.rateType.day': 'Hơi thở{rate}%',
    'loan.tableData.rateType.month': 'Lãi hàng tháng{rate}%',
    'loan.tableData.rateType.year': 'Lãi hàng năm{rate}%',
    'loan.tableData.loanCycleUnit.day': '{loanCycle}Ngày',
    'loan.tableData.loanCycleUnit.month': '{loanCycle}Tháng',
    'loan.confirm.cancelLoan': 'Xác định rút tiền?',
    'loan.cancelLoan.success': 'Rút tiền thành công!',
    'loandetail.tableData.id': 'ID',
    'loandetail.tableData.productName': 'Tên sản phẩm',
    'loandetail.tableData.customerName': 'Họ tên',
    'loandetail.tableData.indexs': 'Số lần',
    'loandetail.tableData.shouldCapital': 'Tiền gốc cần trả',
    'loandetail.tableData.factCapital': 'Tiền gốc trả thực tế ',
    'loandetail.tableData.shouldInterest': 'Lãi suất cần trả',
    'loandetail.tableData.factInterest': 'Lãi suất trả thực tế',
    'loandetail.tableData.shouldFine': 'Lãi phạt cần trả ',
    'loandetail.tableData.factFine': 'Lãi phạt trả thực tế',
    'loandetail.tableData.shouldOtherTotalFee': 'Phí phục vụ cần trả',
    'loandetail.tableData.factOtherTotalFee': 'Phí phục vụ trả thực tế',
    'loandetail.tableData.shouldOverdueFee': 'Phí vi phạm hợp đồng cần trả',
    'loandetail.tableData.factOverdueFee': 'Phí vi phạm hợp đồng trả thực tế',
    'loandetail.tableData.shouldTime': 'Thời gian cần thanh toán',
    'loandetail.tableData.factTime': 'Thời gian nhận tiền thực tế',
    'loandetail.tableData.view': 'Kiểm tra xem',
    'credit.check.tableData.bankName': 'Tên ngân hàng',
    'credit.check.tableData.bankCard': 'Số thẻ ngân hàng',
    'credit.check.tableData.phone': 'Số điện thoại dự trữ',
    'credit.check.tableData.cardNo': 'CMND',
    'credit.check.aciton.view': 'Kiểm tra xem',
    'credit.check.aciton.check': 'Xét duyệt giải ngân ',
    'credit.check.button.reject': 'Từ chối',
    'credit.check.button.approve': 'Đồng ý',
    'credit.check.button.batchReview': 'Đánh giá hàng loạt',
    'credit.check.dialog.remark': 'Ghi chú',
    'credit.check.dialog.rejected': 'Xét duyệt bị từ chối',
    'credit.check.dialog.approved': 'Thông qua xét duyệt ',
    'repayment.state.repaid': 'Đã thanh toán',
    'repayment.state.unpaid': 'Chưa trả',
    'repayment.state.normal': 'Trả nợ bình thường',
    'repayment.state.overdue': 'Quá hạn ',
    'repayment.state.afterOverdue': 'Thanh toán sau khi quá hạn',
    'repayment.state.partial': 'Trả nợ một phần',
    'repayment.state.afterPartial': 'Trả nợ một phần',
    'repayment.state.manual': 'Hướng dẫn viết tắt',
    'repayment.state.cancel': 'Hủy bỏ',
    'repayment.isExtends.notExtends': 'Không mở rộng',
    'repayment.isExtends.extending': 'Mở rộng',
    'repayment.isExtends.extends': 'Đã được mở rộng',
    // 催收核销
    'repayment.hx.status': 'trạng thái',
    'repayment.hx.overrideType': 'loại ghi đè',
    'repayment.hx.orderNumber': 'số thứ tự',
    'repayment.hx.repaymentAmount': 'Số tiền trả nợ',
    'repayment.hx.createTime': 'Thời gian sáng tạo',
    'repayment.hx.updateTime': 'Cập nhật thời gian',
    'repayment.hx.createUserName': 'Creater',
    'repayment.hx.updateUserName': 'người cập nhật',
    'repayment.hx.viewCredentials': 'Xem thông tin đăng nhập',
    'repayment.hx.operating': 'điều hành',
    'repayment.hx.manualOverride': 'Ghi đè thủ công',
    'repayment.hx.partialRepayment': 'Hoàn trả một phần',
    'repayment.hx.normalSettlement': 'Giải quyết bình thường',
    'repayment.hx.cancel': 'hủy bỏ',
    'repayment.tallyBillState.waitApprove': 'Đang chờ xử lý',
    'repayment.tallyBillState.finishApprove': 'Xóa sổ hoàn thành',
    'repayment.tallyBillState.cancelApprove': 'Đã hủy',
    'repayment.tallyBillType.inbursaRepay': 'Thanh toán bằng INBURSA',
    'repayment.tallyBillType.overdueRepay': 'Người dùng hoàn trả sau khi ghi đè quá hạn dài hạn',
    'repayment.hx.noVoucherUpload': 'Không có phiếu thưởng nào được tải lên cho tài liệu hiện tại',
    'repayment.hx.stateNotSupportOperation': 'Trạng thái hiện tại không hỗ trợ hoạt động',
    'repayment.hx.cancelSuccess': 'Hủy thành công',
    'repayment.hx.sureCancel': 'Bạn có chắc chắn sẽ hủy',
    'repayment.hx.cancelFailed': 'Hủy không thành công, vui lòng kiểm tra',
    'nav.subjectMatter.repayment.hx': 'Quản lý lưới',
    /** 支付管理 */
    'common.isDelete': 'Xóa?',
    'status.NameNoNull': 'Trạng thái không thể để trống',
    'sync.member': 'Đồng bộ hóa thông tin thành viên',
    'typeList.filter.time': 'tạo thời gian',
    'outcome.amount': 'Số tiền',
    'callRecord.filter.serialId': 'Chạy số',
    'serviceFee.userId': 'ID người dùng',
    'merchant.scenario': 'Cảnh',
    'icon.copy': 'Sao chép',
    'notice.StatusNoNull': 'Trạng thái thông báo không thể để trống',
    'payType.name': 'loại thanh toán',
    'payType.NoNull': 'Loại thanh toán không thể để trống',
    'merchant.StatusNoNull': 'Người thuê nhà không thể để trống',
    'pri.NoNull': 'Sắp xếp không thể để trống',
    'batch.add': 'Thêm hàng loạt',
    'bank.id': 'ID ngân hàng',
    'bank.name': 'tên ngân hàng',
    'bank.icon': 'biểu tượng',
    'bank.tel': 'Điện thoại liên hệ',
    'bank.website': 'URL trang web chính thức',
    'bank.promptMsg': 'Sao chép nhanh chóng',
    'bank.payType': 'Phương thức thanh toán',
    'bank.status': 'bang',
    'bank.disable': 'hủy kích hoạt',
    'bank.enable': 'Kích hoạt',
    'bank.addDialogTitle': 'Thêm ngân hàng',
    'bank.invalid': 'không hợp lệ',
    'bank.effective': 'hợp lệ',
    'bank.isBatchEnable': 'Nó có được kích hoạt không?',
    'bank.isBatchDisable': 'Bạn có muốn tắt không?',
    'bank.title': 'ngân hàng',
    'bank.config': 'Cấu hình ngân hàng',
    'bank.tenant': 'người thuê nhà',
    'bank.merchantNoNull': 'Người thuê nhà không thể để trống',
    'bank.NoNull': 'Ngân hàng không thể để trống',
    'bank.thridName': 'Tên ba bên',
    'bank.thridBankNameNoNull': 'Tên ba bên không thể để trống',
    'bankCardManage.userId': 'id người dùng',
    'bankCardManage.userName': 'tên',
    'bankCardManage.realName': 'Họ và tên',
    'bankCardManage.firstName': 'tên',
    'bankCardManage.lastName': 'Họ',
    'bankCardManage.expirationYear': 'Năm hiệu lực',
    'bankCardManage.expirationMonth': 'Tháng hiệu lực',
    'bankCardManage.cvv2': 'Mã bảo mật thẻ tín dụng',
    'bankCardManage.tel': 'Số điện thoại di động',
    'bankCardManage.IDCard': 'Số tài liệu',
    'bankCardManage.idType': 'Loại tài liệu',
    'bankCardManage.cardNum': 'số thẻ',
    'bankCardManage.oprType': 'Loại cho vay',
    'bankCardManage.cardType': 'Loại thẻ',
    'bankCardManage.email': 'Hộp thư',
    'bankCardManage.bankName': 'Tên ngân hàng',
    'bankCardManage.bankId': 'Id ngân hàng',
    'bankCardManage.status': 'Trạng thái',
    'bankCardManage.createTime': 'Tạo thời gian',
    'bankCardManage.merchantId': 'Id đối tượng thuê',
    'bankCardManage.addDialogTitle': 'Thêm quản lý thẻ ngân hàng người dùng',
    'bankCardManage.n normal': 'Bình thường',
    'bankCardManage.enable': 'Kích hoạt',
    'bankCardManage.notenable': 'không được bật',
    'bankCardManage.disable': 'Đóng băng',
    'bankCardManage.identityType': 'Thẻ ID',
    'bankCardManage.debitCard': 'Thẻ ghi nợ',
    'bankCardManage.creditCard': 'thẻ tín dụng',
    'bankCardManage.semiCreditCard': 'Thẻ tín dụng gần đúng',
    'bankCardManage.prepaidCard': 'Thẻ trả trước',
    'bankCardManage.valid': 'có xác minh hay không',
    'bankCardManage.notCheck': 'Chưa được xác minh',
    'bankCardManage.passedCheck': 'Xác minh Pass',
    'bankCardManage.failsedCheck': 'Xác minh thất bại',
    'bankCardManage.checking': 'xác minh',
    'bankCardManage.cardNumNoNull': 'Số thẻ không thể để trống',
    'bankCardManage.identityNoNull': 'Số chứng chỉ không thể để trống',
    'bankCardManage.merchantIdNoNull': 'Id đối tượng thuê không thể để trống',
    'bankCardManage.bankIdNoNull': 'Id ngân hàng không thể để trống',
    'bankCardManage.isBatchDisable': 'Nó có bị đóng băng không?',
    'bankCardManage.ifscCode': 'IFSCCode',
    'returnCode.channelNoNull': 'Vui lòng chọn kênh',
    'returnCode.paymentTypeNoNull': 'Vui lòng chọn loại thanh toán',
    'returnCode.name': 'mã trả về',
    'returnCode.returnMsg': 'thông tin trả về',
    'sales.failCount': 'Thất bại',
    'sales.note': 'Ghi chú',
    'sales.documentsState': 'Tình trạng tài liệu',
    'sales.updateTime': 'thời gian cập nhật',
    'sales.documentsNo': 'số ghi chú nhận',
    'sales.realName': 'tên thật',
    'sales.bankCardNo': 'số thẻ ngân hàng',
    'repay.add': 'Thêm',
    'repay.reviewed': 'đã xem xét',
    'repay.doing': 'Đang xử lý',
    'repay.completed': 'Đã hoàn thành',
    'repay.refused': 'Bị từ chối',
    'return.paying': 'Thanh toán',
    'return.pending': 'Đang chờ xử lý',
    'repay.paymentSuccess': 'Thanh toán thành công',
    'repay.paymentFail': 'Thanh toán thất bại',
    'repay.abnormal': 'Ngoại lệ',
    'statusType.submitted': 'Gửi',
    'statusType.pending': 'được xác định',
    'statusType.processing': 'Đang xử lý',
    'statusType.completed': 'Hoàn thành',
    'statusType.error': 'Lỗi',
    'bank.bankNameNoNull': 'Tên ngân hàng không thể để trống',
    'bank.realNameCannot be empty': 'Tên đầy đủ không thể để trống',
    'bank.phoneNoNull': 'Số liên lạc không thể để trống',
    'lending.FinancialCodeExpired': 'Mã tài chính đã hết hạn',
    'lending.HasBeenCancelled': 'Đã hủy',
    'chargeback.add': 'Thêm',
    'chargeback.deducting': 'Khấu trừ',
    'chargeback.completeOfPart': 'Hoàn thành một phần',
    'chargeback.closed': 'Đã đóng',
    'chargeback.allCpmplete': 'Hoàn',
    'chargeback.expireDate': 'Name',
    'chargeback.exception': 'bất thường',
    'deduct.DocumentStatus': 'trạng thái tài liệu',
    'deduct.RepaymentCode': 'Mã trả nợ',
    'deduct.RepaymentPeriodTime': 'Thời gian hoàn trả',
    'deduct.ShouldAlsoAmount': 'nên được hoàn trả',
    'deduct.RepayAmount': 'Số bù nợSố bù nợ',
    'deduct.ActualAmount': 'Số tiền thực',
    'deduct.expireDate': 'thời gian hết hạn',
    'deduct.realAmount': 'Số tiền thực tế',
    'deduct.purchaseCurrency': 'Tiền tệ',
    'Generate return code': 'Tạo mã trả về',
    'Repayment code': 'Mã trả nợMã trả nợ',
    'Repayment trial': 'Thử nghiệm hoàn trả',
    'Try to pay back the principal': 'Cố gắng trả lại tiền gốc',
    'Try to pay interest': 'Cố gắng trả lãi',
    'Try to pay a penalty': 'Cố gắng trả tiền phạt',
    'Trial management fee': 'Phí quản lý dùng thử',
    'Trial total': 'Tổng kết',
    'Repayment channel': 'Kênh thanh toán',
    'repayment.merge.generate': 'Tạo mã hoàn trả ({count})',
    'repayment.merge.selectedPlans': 'Kế hoạch trả nợ đã chọn',
    'repayment.merge.shouldTime': 'Ngày đến hạn',
    'repayment.merge.unpaidAmount': 'Số tiền chưa trả',
    'repayment.merge.overdueFee': 'Phí quá hạn thử tính',
    'repayment.merge.openLink': 'Mở liên kết thanh toán',
    'repayment.merge.previewFailed': 'Tính toán trả nợ gộp thất bại',
    'repayment.merge.invalidState': 'Chỉ có thể chọn hóa đơn chưa thanh toán, quá hạn hoặc đã thanh toán một phần',
    'repayment.merge.sameMainBillRequired': 'Chỉ có thể gộp kế hoạch trả nợ thuộc cùng một hóa đơn chính',
    'channel.loanDocuments': 'Biên lai khoản vay',
    'channel.orderNo': 'số thứ tự',
    'channel.outcomeId': 'Số thứ tự cho vay',
    'channel.oanApplicationDate': 'Ngày đăng ký thanh toán',
    'channel.loanAmount': 'Số tiền cho vay',
    'channel.loanTime': 'Thời gian cho vay',
    'channel.pleaseEnterTheLoanTime': 'Vui lòng chọn thời gian cho vay',
    'channel.lendingDate': 'Ngày cho vay thực tế',
    'channel.lendingApplyDate': 'Ngày cho vay',
    'channel.name': 'tên',
    'channel.idNo': 'số tài liệu',
    'channel.bvn': 'BVN',
    'channel.payStatus': 'Trạng thái thanh toán',
    'channel.confirmTheLoan': 'Xác nhận khoản vay',
    'channel.lendingAgain': 'Cho vay lại',
    'channel.cancelLending': 'Hủy khoản vay',
    'channel.Invalid': 'Không hợp lệ',
    'channel.isConfirmTheLoan': 'Bạn có xác nhận khoản vay không?',
    'channel.isConfirmTheLoanFailure': 'Bạn có xác nhận rằng khoản vay không thành công không?',
    'channel.isLoanSuccess': 'Bạn có xác nhận rằng khoản vay đã thành công không?',
    'channel.isConfirmLendingAgain': 'Bạn có muốn xác nhận cho vay lại không?',
    'channel.isConfirmCancelLending': 'Bạn có chắc chắn hủy khoản vay không?',
    'channel.loanSuccess': 'Cho vay tiềnCho vay tiền',
    'channel.loanSuccessBatch': 'Cho vay hàng loạt thành công',
    'channel.manualLending': 'Cho vay thủ công',
    'channel.systemLending': 'cho vay hệ thống',
    'channel.loanFailure': 'Mất thất bại',
    'channel.loanExport': 'Xuất khẩu',
    'channel.notPaying': 'Chưa thanh toán',
    'channel.changeOprType': 'thay đổi loại hình giải ngân',
    'channel.isConfirmChangeOprType': 'có thay đổi từ giải ngân bằng tay thành giải ngân online không?',
    'channel.businessParam': 'Cho dù khách hàng vay lại',
    'channel.firstLoan': 'Nếu không',
    'channel.doubleLoan': 'là',
    'channel.channel': 'Kênh',
    'channel.bankCoding': 'Mã ngân hàng',
    'channel.NoNull': 'Kênh không thể trống',
    'channel.threePartiesMerchantNumber': 'Số thương gia ba bên',
    'channel.merchantNoNull': 'Số thương gia ba bên không thể để trống',
    'channel.channelName': 'tên kênh',
    'channel.channelID': 'ID kênh',
    'channel.channelNumber': 'số kênh',
    'channel.createTime': 'tạo thời gian',
    'channel.theTemporaryClosureOfOpenTime': 'Tạm thời tắt đúng giờ',
    'channel.theTemporaryClosureOfTheEndOfTime': 'Thời gian kết thúc tắt máy tạm thời',
    'channel.rule.channelID': 'Bao gồm số, chữ cái và dấu gạch dưới, trong vòng 20 ký tự',
    'channel.rule.channelName': 'Tên quy tắc trong vòng 20 ký tự',
    'channel.rule.channelNumber': 'Trong vòng 100 ký tự',
    'routing.sorting': 'sắp xếp',
    'routing.weight': 'Trọng số',
    'routing.weightRequired': 'Trọng số không được để trống',
    'routing.weightInvalid': 'Trọng số phải là số nguyên không âm',
    'routing.singleLimit': 'giới hạn đơn',
    'routing.singleMinimumLimit': 'giới hạn tối thiểu duy nhất',
    'routing.dailyLimit': 'giới hạn một ngày',
    'routing.monthlyAllowance': 'giới hạn một tháng',
    'routing.theTemporaryClosureOfInformation': 'Thông tin tắt tạm thời',
    'routing.basicInformation': 'Thông tin cơ bản',
    'routing.lendingDetail': 'Chi tiết thanh toán khoản vay',
    'routing.repaymentDetail': 'Chi tiết thanh toán trả nợ',
    'routing.pauseCollection': 'Tạm dừng thu hồi nợ',
    'routing.resumeCollection': 'Tiếp tục thu hồi nợ',
    'payment.sourceMerchantId': 'ID đối tượng thuê nguồn',
    'payment.targetMerchantId': 'ID đối tượng thuê mục tiêu',
    'base.three.part.config': 'Cấu hình ba bên',
    'base.three.part.config.type': 'Loại thanh toán',
    'base.three.part.config.channel': 'Kênh',
    'base.three.part.config.add': 'Thêm số lượng lớn',
    'base.three.part.config.delete': 'xóa',
    'base.three.part.config.modify': 'Sửa đổi',
    'base.three.part.config.id': 'khóa chính tham số',
    'base.three.part.config.channel.id': 'ID kênh',
    'base.three.part.config.channel.name': 'Tên kênh',
    'base.three.part.config.payment.type': 'Loại thanh toán',
    'base.three.part.config.payment.desc': 'Mô tả loại thanh toán',
    'base.three.part.config.key': 'khóa',
    'base.three.part.config.value': 'value',
    'base.three.part.rules.key': 'Vui lòng nhập khóa',
    'nav.bank.bankcard.title': 'Quản lý thẻ ngân hàng người dùng',
    'nav.bank.title': 'quản lý thẻ ngân hàng',
    'nav.receipt.title': 'Quản lý tài liệu',
    'nav.receipt.lending.title': 'Biên lai khoản vay',
    'nav.receipt.lending.detail.title': 'Chi tiết khoản vay',
    'nav.receipt.repayment.title': 'Biên lai thanh toán',
    'nav.receipt.repayment.detail.title': 'Chi tiết trả nợ',
    'nav.routing.title': 'Chi tiết trả nợ',
    'nav.routing.lending.title': 'Định tuyến khoản vay',
    'nav.routing.repayment.title': 'Định tuyến thanh toán',
    'nav.channel.title': 'Cấu hình kênh',
    'nav.channel.compare.title': 'Các kênh và ngân hàng',
    'nav.channel.threepart.title': 'Thông số kênh',
    'nav.channel.channel.title': 'Danh sách kênh',
    'nav.channel.merchant.title': 'Cấu hình người thuê',
    'nav.channel.bank.title': 'Người thuê và ngân hàng'
}
